import React from "react";
export const LOCALE = process.env.LOCALE

export const dataQuestions = {
    'es-CO': [
        {
            idQuestion: 1,
            titleQuestion: "¿Cuáles son las ventajas de las nuevas Toallas Nosotras Buenas Noches Máxima Protección?",
            answerQuestion: "Las nuevas Toallas Nosotras Buenas Noches Máxima Protección, te protegen para que disfrutes de un mejor sueño y mayor comodidad durante las noches de flujo abundante, ya que tienen una protección 360° que cubre tu cuerpo sin dejar que ocurra ningún accidente. Es tan fácil de usar como tu  panty de uso diario.",
        },
        {
            idQuestion: 2,
            titleQuestion: "¿Quién puede usar las nuevas Toallas Nosotras Buenas Noches Máxima Protección?",
            answerQuestion: "Mujeres con flujo abundante, que durante la noche deben levantarse varias veces para cambiar su toalla, evitando un sueño placentero.",
        },
        {
            idQuestion: 3,
            titleQuestion: "¿Por qué usar las Toallas Nosotras Buenas Noches Máxima Protección en lugar de las Toallas Buenas Noches? ¿En qué se diferencian?",
            answerQuestion: (
                <span>
                    Las nuevas Toallas Nosotras Buenas Noches Máxima Protección, se adaptan mejor al cuerpo por su diseño 360° y brindan mayor protección a las mujeres que están siempre preocupadas de pasar una mala noche, debido a la inseguridad de mancharse.
                    <br />
                    Con este innovador producto, ya no es necesario levantarse en plena noche para cambiarse, como lo hacen algunas mujeres al usar toallas Buenas Noches normales. Puedes  estar segura de que su tecnología  360° te protegerá mientras duermes.
                </span>
            ),
        },
        {
            idQuestion: 4,
            titleQuestion: "¿Qué características tienen las nuevas Toallas Nosotras Buenas Noches Máxima Protección?",
            answerQuestion: (
                <span>
                    <ul>
                        <li>Tienen una protección 360° hecha de materiales suaves y respirables, para un sueño más tranquilo y noches de completo descanso. </li>
                        <li>Tienen un diseño único que contribuye a brindar 30% más absorción que las Toallas Buenas noches.</li>
                        <li>Tienen un área de absorción de 373 mm de largo, más larga y más ancha que una toalla Buenas noches normal.</li>
                        <li>Están hechas con microcápsulas superabsorbentes que absorben rápidamente el flujo y lo retienen en su interior.</li>
                        <li>Diseñadas con dos barreras de protección laterales para evitar fugas por los lados</li>
                        <li>Hechas de un material ligero y transpirable que se ajusta cómodamente alrededor de tu cuerpo y mantiene la toalla Nosotras Buenas noches máxima protección en su sitio, para evitar cualquier posible accidente, permitiendo que puedas moverte libremente mientras duermes.</li>
                        <li>Estas toallas vienen en tres diferentes tallas S/M/L-XL para que se ajusten mejor a cada cuerpo.</li>
                    </ul>
                </span>
            ),
        },
        {
            idQuestion: 5,
            titleQuestion: "¿Cómo usar las nuevas Toallas Nosotras Buenas Noches Máxima Protección?",
            answerQuestion: "Úsalas del mismo modo que tus panties, sin necesidad de usar ropa interior durante la noche. Usa tu pijama encima, disfruta de un sueño reparador y deséchalas a la caneca de basura en la mañana. ",
        },
        {
            idQuestion: 6,
            titleQuestion: "¿Cuándo debo utilizar las nuevas Toallas Nosotras Buenas Noches Máxima Protección?",
            answerQuestion: "Úsalas durante las noches que tienes un flujo más abundante. Además, puedes usarlas en viajes largos donde no tengas fácil acceso a un baño para cambiarte, después de dar a luz o en cualquier otra situación en la que necesites  extra protección para sentirte siempre segura.",
        },
        {
            idQuestion: 7,
            titleQuestion: "¿En qué tallas están disponibles las nuevas Toallas Nosotras Buenas Noches Máxima Protección?",
            answerQuestion: (
                <span>
                    Encuentra y escoge tu talla igual que lo haces con tu ropa interior normal.
                    <ul>
                        <li>Talla Pequeña (S) si tu cadera mide entre 75 y 95 cm. </li>
                        <li>Talla mediana (M) si tu cadera mide entre 95 y 105 cm.</li>
                        <li>Talla Grande (L-XL) si tu cadera mide entre 105 y 115 cm.</li>
                    </ul>
                </span>
            ),
        },
        {
            idQuestion: 8,
            titleQuestion: "¿Con qué frecuencia se recomienda cambiar las Toallas Nosotras Buenas Noches Máxima Protección?",
            answerQuestion: "Con este nuevo producto ya no tienes que levantarte durante la noche para cambiarte. Puedes usarlas antes de irte a dormir y desecharlas en la mañana. Solo necesitaras 1 toalla buenas noches máxima protección para toda la noche.",
        },
        {
            idQuestion: 9,
            titleQuestion: "¿Cómo me deshago de las Toallas Nosotras Buenas Noches Máxima Protección, después de usadas?",
            answerQuestion: "Al levantarte por la mañana, solo tienes que quitarte la toalla igual que como te retiras la ropa interior, doblarla y tirarla a la basura.",
        },
    ],
    'es-CL': [
        {
            idQuestion: 1,
            titleQuestion: "¿Cuáles son las ventajas del nuevo Calzón Nocturno Nosotras Máxima Protección?",
            answerQuestion: "El nuevo Calzón Nocturno Nosotras Máxima Protección, te protegen para que disfrutes de un mejor sueño y mayor comodidad durante las noches de flujo abundante, ya que tienen una protección 360° que cubre tu cuerpo sin dejar que ocurra ningún accidente. Es tan fácil de usar como tu ropa interior de uso diario.",
        },
        {
            idQuestion: 2,
            titleQuestion: "¿Quién puede usar el nuevo Calzón Nocturno Nosotras Máxima Protección?",
            answerQuestion: "Mujeres con flujo abundante, que durante la noche deben levantarse varias veces para cambiar su ropa interior, evitando un sueño placentero.",
        },
        {
            idQuestion: 3,
            titleQuestion: "¿Por qué usar el Calzón Nocturno Nosotras Máxima Protección en lugar de las Toallas Buenas Noches? ¿En qué se diferencian?",
            answerQuestion: (
                <span>
                    El nuevo Calzón Nocturno Nosotras Máxima Protección, se adapta mejor al cuerpo por su diseño 360° y brindan mayor protección a las mujeres que están siempre preocupadas de pasar una mala noche, debido a la inseguridad de mancharse.
                    <br />
                    Con este innovador producto, ya no es necesario levantarse en plena noche para cambiarse, como lo hacen algunas mujeres al usar toallas Buenas Noches normales. Puedes  estar segura de que su tecnología  360° te protegerá mientras duermes.
                </span>
            ),
        },
        {
            idQuestion: 4,
            titleQuestion: "¿Qué características tiene el Nuevo Calzón Nocturno Nosotras Máxima Protección?",
            answerQuestion: (
                <span>
                    <ul>
                        <li>Tienen una protección 360° hecha de materiales suaves y respirables, para un sueño más tranquilo y noches de completo descanso. </li>
                        <li>Tienen un diseño único que contribuye a brindar 30% más absorción que las Toallas Buenas noches.</li>
                        <li>Tienen un área de absorción de 373 mm de largo, más larga y más ancha que una toalla Buenas noches normal.</li>
                        <li>Están hechas con microcápsulas superabsorbentes que absorben rápidamente el flujo y lo retienen en su interior.</li>
                        <li>Diseñadas con dos barreras de protección laterales para evitar fugas por los lados</li>
                        <li>Hechas de un material ligero y transpirable que se ajusta cómodamente alrededor de tu cuerpo y mantiene El Calzón Nocturno Nosotras Máxima Protección en su sitio, para evitar cualquier posible accidente, permitiendo que puedas moverte libremente mientras duermes.</li>
                        <li>Este Calzón viene en tres diferentes tallas S/M/L-XL para que se ajusten mejor a cada cuerpo.</li>
                    </ul>
                </span>
            ),
        },
        {
            idQuestion: 5,
            titleQuestion: "¿Cómo usar el Nuevo Calzón Nocturno Nosotras Máxima Protección?",
            answerQuestion: "Úsalo, sin necesidad de usar ropa interior durante la noche. Usa tu pijama encima, disfruta de un sueño reparador y deséchalas al basurero en la mañana. ",
        },
        {
            idQuestion: 6,
            titleQuestion: "¿Cuándo debo utilizar el nueva Calzón Nocturno Nosotras Máxima Protección?",
            answerQuestion: "Úsalas durante las noches que tienes un flujo más abundante. Además, puedes usarlas en viajes largos donde no tengas fácil acceso a un baño para cambiarte, después de dar a luz o en cualquier otra situación en la que necesites  extra protección para sentirte siempre segura.",
        },
        {
            idQuestion: 7,
            titleQuestion: "¿En qué tallas están disponibles el Nuevo Calzón Nocturno Nosotras Máxima Protección?",
            answerQuestion: (
                <span>
                    Encuentra y escoge tu talla igual que lo haces con tu ropa interior normal.
                    <ul>
                        <li>Talla Pequeña (S) si tu cadera mide entre 75 y 95 cm. </li>
                        <li>Talla mediana (M) si tu cadera mide entre 95 y 105 cm.</li>
                        <li>Talla Grande (L-XL) si tu cadera mide entre 105 y 115 cm.</li>
                    </ul>
                </span>
            ),
        },
        {
            idQuestion: 8,
            titleQuestion: "¿Con qué frecuencia se recomienda cambiar el Calzón Nocturno Nosotras Máxima Protección?",
            answerQuestion: "Con este nuevo producto ya no tienes que levantarte durante la noche para cambiarte. Puedes usarlas antes de irte a dormir y desecharlas en la mañana. Solo necesitaras 1 Calzón Nocturno Nosotras Máxima Protección para toda la noche.",
        },
        {
            idQuestion: 9,
            titleQuestion: "¿Cómo me deshago del Calzón Nocturno Nosotras Máxima Protección, después de usadas?",
            answerQuestion: "Al levantarte por la mañana, solo tienes que quitarte El Calzón igual que como te retiras la ropa interior, doblarla y tirarla a la basura.",
        },
    ],
    'es-PE': [
        {
            idQuestion: 1,
            titleQuestion: "¿Cuáles son las ventajas del nuevo Calzón Nocturno Nosotras Máxima Protección?",
            answerQuestion: "Las nuevas Toallas Nosotras Buenas Noches Máxima Protección, te protegen para que disfrutes de un mejor sueño y mayor comodidad durante las noches de flujo abundante, ya que tienen una protección 360° que cubre tu cuerpo sin dejar que ocurra ningún accidente. Es tan fácil de usar como tu ropa interior de uso diario.",
        },
        {
            idQuestion: 2,
            titleQuestion: "¿Quién puede usar el nuevo Calzón Nocturno Nosotras Máxima Protección?",
            answerQuestion: "Mujeres con flujo abundante, que durante la noche deben levantarse varias veces para cambiar su toalla, evitando un sueño placentero.",
        },
        {
            idQuestion: 3,
            titleQuestion: "¿Por qué usar el Calzón Nocturno Nosotras Máxima Protección en lugar de las Toallas Buenas Noches? ¿En qué se diferencian?",
            answerQuestion: (
              <span>
                    Las nuevas Toallas Nosotras Buenas Noches Máxima Protección, se adaptan mejor al cuerpo por su diseño 360° y brindan mayor protección a las mujeres que están siempre preocupadas de pasar una mala noche, debido a la inseguridad de mancharse.
                    <br />
                    Con este innovador producto, ya no es necesario levantarse en plena noche para cambiarse, como lo hacen algunas mujeres al usar toallas Buenas Noches normales. Puedes  estar segura de que su tecnología  360° te protegerá mientras duermes.
                </span>
            ),
        },
        {
            idQuestion: 4,
            titleQuestion: "¿Qué características tiene el Nuevo Calzón Nocturno Nosotras Máxima Protección?",
            answerQuestion: (
              <span>
                    <ul>
                        <li>Tienen una protección 360° hecha de materiales suaves y respirables, para un sueño más tranquilo y noches de completo descanso. </li>
                        <li>Tienen un diseño único que contribuye a brindar 30% más absorción que las Toallas Buenas noches.</li>
                        <li>Tienen un área de absorción de 37,3 cm de largo, más larga y más ancha que una toalla Buenas noches normal.</li>
                        <li>Están hechas con microcápsulas superabsorbentes que absorben rápidamente el flujo y lo retienen en su interior.</li>
                        <li>Diseñadas con dos barreras de protección laterales para evitar fugas por los lados</li>
                        <li>Hechas de un material ligero y transpirable que se ajusta cómodamente alrededor de tu cuerpo y mantiene la toalla Nosotras Buenas noches máxima protección en su sitio, para evitar cualquier posible accidente, permitiendo que puedas moverte libremente mientras duermes.</li>
                        <li>Estas toallas vienen en tres diferentes tallas S/M/L-XL para que se ajusten mejor a cada cuerpo.</li>
                    </ul>
                </span>
            ),
        },
        {
            idQuestion: 5,
            titleQuestion: "¿Cómo usar el Nuevo Calzón Nocturno Nosotras Máxima Protección?",
            answerQuestion: "Úsalas del mismo modo que tu ropa interior, sin necesidad de usarlas durante la noche. Usa tu pijama encima, disfruta de un sueño reparador y deséchalas en el tacho de basura en la mañana. ",
        },
        {
            idQuestion: 6,
            titleQuestion: "¿Cuándo debo utilizar el nueva Calzón Nocturno Nosotras Máxima Protección?",
            answerQuestion: "Úsalas durante las noches que tienes un flujo más abundante. Además, puedes usarlas en viajes largos donde no tengas fácil acceso a un baño para cambiarte, después de dar a luz o en cualquier otra situación en la que necesites  extra protección para sentirte siempre segura.",
        },
        {
            idQuestion: 7,
            titleQuestion: "¿En qué tallas están disponibles el Nuevo Calzón Nocturno Nosotras Máxima Protección?",
            answerQuestion: (
              <span>
                    Encuentra y escoge tu talla igual que lo haces con tu ropa interior normal.
                    <ul>
                        <li>Talla Pequeña (S) si tu cadera mide entre 75 y 95 cm. </li>
                        <li>Talla mediana (M) si tu cadera mide entre 95 y 105 cm.</li>
                        <li>Talla Grande (L-XL) si tu cadera mide entre 105 y 115 cm.</li>
                    </ul>
                </span>
            ),
        },
        {
            idQuestion: 8,
            titleQuestion: "¿Con qué frecuencia se recomienda cambiar el Calzón Nocturno Nosotras Máxima Protección?",
            answerQuestion: "Con este nuevo producto ya no tienes que levantarte durante la noche para cambiarte. Puedes usarlas antes de irte a dormir y desecharlas en la mañana. Solo necesitaras 1 toalla buenas noches máxima protección para toda la noche.",
        },
        {
            idQuestion: 9,
            titleQuestion: "¿Cómo me deshago del Calzón Nocturno Nosotras Máxima Protección, después de usadas?",
            answerQuestion: "Al levantarte por la mañana, solo tienes que quitarte la toalla igual que como te retiras la ropa interior, doblarla y tirarla a la basura.",
        },
    ],
    'es-DO': [
        {
            idQuestion: 1,
            titleQuestion: "¿Cuáles son las ventajas del Nuevo Nosotras Panty Nocturno con Máxima Protección 360?",
            answerQuestion: "El Nuevo Nosotras Panty Nocturno con Máxima Protección 360, te protegen para que disfrutes de un mejor sueño y mayor comodidad durante las noches de flujo abundante, ya que tienen una protección 360° que cubre tu cuerpo sin dejar que ocurra ningún accidente. Es tan fácil de usar como tu  panty de uso diario.",
        },
        {
            idQuestion: 2,
            titleQuestion: "¿Quién puede usar el Nuevo Nosotras Panty Nocturno con Máxima Protección 360?",
            answerQuestion: "Mujeres con flujo abundante, que durante la noche deben levantarse varias veces para cambiar su Panty, evitando un sueño placentero.",
        },
        {
            idQuestion: 3,
            titleQuestion: "¿Por qué usar el Nuevo Nosotras Panty Nocturno con Máxima Protección 360 en lugar de las Toallas Buenas Noches? ¿En qué se diferencian?",
            answerQuestion: (
                <span>
                    El Nuevo Nosotras Panty Nocturno con Máxima Protección 360, se adaptan mejor al cuerpo por su diseño 360° y brindan mayor protección a las mujeres que están siempre preocupadas de pasar una mala noche, debido a la inseguridad de mancharse.
                    <br />
                    Con este innovador producto, ya no es necesario levantarse en plena noche para cambiarse, como lo hacen algunas mujeres al usar toallas Buenas Noches normales. Puedes  estar segura de que su tecnología  360° te protegerá mientras duermes.
                </span>
            ),
        },
        {
            idQuestion: 4,
            titleQuestion: "¿Qué características tienen el Nuevo Nosotras Panty Nocturno con Máxima Protección 360?",
            answerQuestion: (
                <span>
                    <ul>
                        <li>Tienen una protección 360° hecha de materiales suaves y respirables, para un sueño más tranquilo y noches de completo descanso. </li>
                        <li>Tienen un diseño único que contribuye a brindar 30% más absorción que las Toallas Buenas noches.</li>
                        <li>Tienen un área de absorción de 373 mm de largo, más larga y más ancha que una toalla Buenas noches normal.</li>
                        <li>Están hechos con microcápsulas superabsorbentes que absorben rápidamente el flujo y lo retienen en su interior.</li>
                        <li>Diseñados con dos barreras de protección laterales para evitar fugas por los lados</li>
                        <li>Hechos de un material ligero y transpirable que se ajusta cómodamente alrededor de tu cuerpo y mantiene el Nuevo Nosotras Panty Nocturno con Máxima Protección 360 en su sitio, para evitar cualquier posible accidente, permitiendo que puedas moverte libremente mientras duermes.</li>
                        <li>Estos Nuevos Nosotras Panty Nocturno con Máxima Protección 360 vienen en tres diferentes tallas S/M/L-XL para que se ajusten mejor a cada cuerpo.</li>
                    </ul>
                </span>
            ),
        },
        {
            idQuestion: 5,
            titleQuestion: "¿Cómo usar el Nuevo Nosotras Panty Nocturno con Máxima Protección 360?",
            answerQuestion: "Úsalos del mismo modo que tus panties, sin necesidad de usar ropa interior durante la noche. Usa tu pijama encima, disfruta de un sueño reparador y deséchalos a la caneca de basura en la mañana. ",
        },
        {
            idQuestion: 6,
            titleQuestion: "¿Cuándo debo utilizar el Nuevo Nosotras Panty Nocturno con Máxima Protección 360?",
            answerQuestion: "Úsalos durante las noches que tienes un flujo más abundante. Además, puedes usarlos en viajes largos donde no tengas fácil acceso a un baño para cambiarte, después de dar a luz o en cualquier otra situación en la que necesites  extra protección para sentirte siempre segura.",
        },
        {
            idQuestion: 7,
            titleQuestion: "¿En qué tallas están disponibles el Nuevo Nosotras Panty Nocturno con Máxima Protección 360?",
            answerQuestion: (
                <span>
                    Encuentra y escoge tu talla igual que lo haces con tu ropa interior normal.
                    <ul>
                        <li>Talla Pequeña (S) si tu cadera mide entre 75 y 95 cm. </li>
                        <li>Talla mediana (M) si tu cadera mide entre 95 y 105 cm.</li>
                        <li>Talla Grande (L-XL) si tu cadera mide entre 105 y 115 cm.</li>
                    </ul>
                </span>
            ),
        },
        {
            idQuestion: 8,
            titleQuestion: "¿Con qué frecuencia se recomienda cambiar el Nuevo Nosotras Panty Nocturno con Máxima Protección 360?",
            answerQuestion: "Con este nuevo producto ya no tienes que levantarte durante la noche para cambiarte. Puedes usarlas antes de irte a dormir y desecharlos en la mañana. Solo necesitaras 1 Nosotras Panty Nocturno con Máxima Proteccion 360.",
        },
        {
            idQuestion: 9,
            titleQuestion: "¿Cómo me deshago del Nuevo Nosotras Panty Nocturno con Máxima Protección 360, después de usados?",
            answerQuestion: "Al levantarte por la mañana, solo tienes que quitarte el Panty igual que como te retiras la ropa interior, doblarlo y tirarlo a la basura.",
        },
    ],
    'es-EC': [
        {
            idQuestion: 1,
            titleQuestion: "¿Cuáles son las ventajas de las nuevas Toallas Nosotras Buenas Noches Máxima Protección?",
            answerQuestion: "Las nuevas Toallas Nosotras Buenas Noches Máxima Protección, te protegen para que disfrutes de un mejor sueño y mayor comodidad durante las noches de flujo abundante, ya que tienen una protección 360° que cubre tu cuerpo sin dejar que ocurra ningún accidente. Es tan fácil de usar como tu  panty de uso diario.",
        },
        {
            idQuestion: 2,
            titleQuestion: "¿Quién puede usar las nuevas Toallas Nosotras Buenas Noches Máxima Protección?",
            answerQuestion: "Mujeres con flujo abundante, que durante la noche deben levantarse varias veces para cambiar su toalla, evitando un sueño placentero.",
        },
        {
            idQuestion: 3,
            titleQuestion: "¿Por qué usar las Toallas Nosotras Buenas Noches Máxima Protección en lugar de las Toallas Buenas Noches? ¿En qué se diferencian?",
            answerQuestion: (
                <span>
                    Las nuevas Toallas Nosotras Buenas Noches Máxima Protección, se adaptan mejor al cuerpo por su diseño 360° y brindan mayor protección a las mujeres que están siempre preocupadas de pasar una mala noche, debido a la inseguridad de mancharse.
                    <br />
                    Con este innovador producto, ya no es necesario levantarse en plena noche para cambiarse, como lo hacen algunas mujeres al usar toallas Buenas Noches normales. Puedes  estar segura de que su tecnología  360° te protegerá mientras duermes.
                </span>
            ),
        },
        {
            idQuestion: 4,
            titleQuestion: "¿Qué características tienen las nuevas Toallas Nosotras Buenas Noches Máxima Protección?",
            answerQuestion: (
                <span>
                    <ul>
                        <li>Tienen una protección 360° hecha de materiales suaves y respirables, para un sueño más tranquilo y noches de completo descanso. </li>
                        <li>Tienen un diseño único que contribuye a brindar 30% más absorción que las Toallas Buenas noches.</li>
                        <li>Tienen un área de absorción de 373 mm de largo, más larga y más ancha que una toalla Buenas noches normal.</li>
                        <li>Están hechas con microcápsulas superabsorbentes que absorben rápidamente el flujo y lo retienen en su interior.</li>
                        <li>Diseñadas con dos barreras de protección laterales para evitar fugas por los lados</li>
                        <li>Hechas de un material ligero y transpirable que se ajusta cómodamente alrededor de tu cuerpo y mantiene la toalla Nosotras Buenas noches máxima protección en su sitio, para evitar cualquier posible accidente, permitiendo que puedas moverte libremente mientras duermes.</li>
                        <li>Estas toallas vienen en tres diferentes tallas S/M/L-XL para que se ajusten mejor a cada cuerpo.</li>
                    </ul>
                </span>
            ),
        },
        {
            idQuestion: 5,
            titleQuestion: "¿Cómo usar las nuevas Toallas Nosotras Buenas Noches Máxima Protección?",
            answerQuestion: "Úsalas del mismo modo que tus panties, sin necesidad de usar ropa interior durante la noche. Usa tu pijama encima, disfruta de un sueño reparador y deséchalos a la basura en la mañana. ",
        },
        {
            idQuestion: 6,
            titleQuestion: "¿Cuándo debo utilizar las nuevas Toallas Nosotras Buenas Noches Máxima Protección?",
            answerQuestion: "Úsalas durante las noches que tienes un flujo más abundante. Además, puedes usarlas en viajes largos donde no tengas fácil acceso a un baño para cambiarte, después de dar a luz o en cualquier otra situación en la que necesites  extra protección para sentirte siempre segura.",
        },
        {
            idQuestion: 7,
            titleQuestion: "¿En qué tallas están disponibles las nuevas Toallas Nosotras Buenas Noches Máxima Protección?",
            answerQuestion: (
                <span>
                    Encuentra y escoge tu talla igual que lo haces con tu ropa interior normal.
                    <ul>
                        <li>Talla Pequeña (S) si tu cadera mide entre 75 y 95 cm. </li>
                        <li>Talla mediana (M) si tu cadera mide entre 95 y 105 cm.</li>
                        <li>Talla Grande (L-XL) si tu cadera mide entre 105 y 115 cm.</li>
                    </ul>
                </span>
            ),
        },
        {
            idQuestion: 8,
            titleQuestion: "¿Con qué frecuencia se recomienda cambiar las Toallas Nosotras Buenas Noches Máxima Protección?",
            answerQuestion: "Con este nuevo producto ya no tienes que levantarte durante la noche para cambiarte. Puedes usarlas antes de irte a dormir y desecharlas en la mañana. Solo necesitaras 1 toalla buenas noches máxima protección para toda la noche.",
        },
        {
            idQuestion: 9,
            titleQuestion: "¿Cómo me deshago de las Toallas Nosotras Buenas Noches Máxima Protección, después de usarlas?",
            answerQuestion: "Al levantarte por la mañana, solo tienes que quitarte la toalla igual que como te retiras la ropa interior, doblarla y tirarla a la basura.",
        },
    ],
  }[LOCALE]
